import React, { useState } from 'react';
import { ArrowLeft, Download, Calendar, Users, MessageSquare, TrendingUp, Clock, Target, Lightbulb, BookOpen, Award, Zap } from 'lucide-react';
import { StarField } from '../components/Background/StarField';
export function AITutorPage() {
  const [timeRange, setTimeRange] = useState('week');
  // 模拟数据 - 基于原型图
  const data = {
    // 顶部统计卡片
    overview: {
      totalSessions: 15847,
      activeStudents: 2856,
      avgSessionTime: 18.5,
      satisfactionRate: 96,
      questionsSolved: 12456,
      knowledgePointsCovered: 856
    },
    // AI对话质量分析
    conversationQuality: {
      clarityScore: 94,
      relevanceScore: 92,
      depthScore: 88,
      guidanceScore: 95
    },
    // 学习模式分布
    learningModeDistribution: [{
      mode: '苏格拉底式引导',
      percentage: 45,
      count: 7131,
      color: '#A78BFA'
    }, {
      mode: '知识点讲解',
      percentage: 30,
      count: 4754,
      color: '#38BDF8'
    }, {
      mode: '习题辅导',
      percentage: 15,
      count: 2377,
      color: '#F472B6'
    }, {
      mode: '思维训练',
      percentage: 10,
      count: 1585,
      color: '#FB923C'
    }],
    // 热门问题类型
    popularQuestionTypes: [{
      type: '概念理解',
      count: 3245,
      percentage: 26
    }, {
      type: '解题方法',
      count: 2987,
      percentage: 24
    }, {
      type: '知识拓展',
      count: 2156,
      percentage: 17
    }, {
      type: '错题分析',
      count: 1876,
      percentage: 15
    }, {
      type: '学习建议',
      count: 1543,
      percentage: 12
    }, {
      type: '其他',
      count: 649,
      percentage: 6
    }],
    // 学科使用情况
    subjectUsage: [{
      subject: '数学',
      sessions: 4256,
      avgTime: 22,
      satisfaction: 95
    }, {
      subject: '物理',
      sessions: 3187,
      avgTime: 19,
      satisfaction: 93
    }, {
      subject: '化学',
      sessions: 2845,
      avgTime: 17,
      satisfaction: 94
    }, {
      subject: '英语',
      sessions: 2134,
      avgTime: 15,
      satisfaction: 96
    }, {
      subject: '语文',
      sessions: 1987,
      avgTime: 20,
      satisfaction: 92
    }, {
      subject: '生物',
      sessions: 1438,
      avgTime: 16,
      satisfaction: 94
    }],
    // 学生参与度趋势
    engagementTrend: [{
      date: '07-25',
      sessions: 1856,
      avgTime: 17
    }, {
      date: '07-26',
      sessions: 1923,
      avgTime: 18
    }, {
      date: '07-27',
      sessions: 2045,
      avgTime: 19
    }, {
      date: '07-28',
      sessions: 2187,
      avgTime: 18
    }, {
      date: '07-29',
      sessions: 2356,
      avgTime: 20
    }, {
      date: '07-30',
      sessions: 2489,
      avgTime: 19
    }, {
      date: '07-31',
      sessions: 2634,
      avgTime: 21
    }],
    // 思维能力提升
    thinkingSkillsImprovement: [{
      skill: '逻辑推理',
      improvement: 85,
      baseline: 68
    }, {
      skill: '批判性思维',
      improvement: 78,
      baseline: 62
    }, {
      skill: '创造性思维',
      improvement: 72,
      baseline: 58
    }, {
      skill: '问题解决',
      improvement: 88,
      baseline: 71
    }, {
      skill: '分析能力',
      improvement: 82,
      baseline: 66
    }],
    // 学习效果评估
    learningEffectiveness: {
      knowledgeRetention: 89,
      conceptUnderstanding: 92,
      applicationAbility: 85,
      selfLearningAbility: 87
    },
    // 高频知识点
    topKnowledgePoints: [{
      rank: 1,
      point: '函数性质',
      queries: 856,
      subject: '数学'
    }, {
      rank: 2,
      point: '电磁感应',
      queries: 743,
      subject: '物理'
    }, {
      rank: 3,
      point: '化学平衡',
      queries: 687,
      subject: '化学'
    }, {
      rank: 4,
      point: '语法结构',
      queries: 621,
      subject: '英语'
    }, {
      rank: 5,
      point: '文言文阅读',
      queries: 578,
      subject: '语文'
    }],
    // 各时段使用分布
    timeDistribution: [{
      period: '早晨(6-9点)',
      percentage: 15,
      count: 2377
    }, {
      period: '上午(9-12点)',
      percentage: 20,
      count: 3169
    }, {
      period: '下午(12-18点)',
      percentage: 25,
      count: 3962
    }, {
      period: '晚上(18-22点)',
      percentage: 35,
      count: 5546
    }, {
      period: '深夜(22-24点)',
      percentage: 5,
      count: 792
    }],
    // AI响应质量
    responseQuality: {
      avgResponseTime: 1.2,
      accuracyRate: 96,
      completenessRate: 94,
      helpfulnessScore: 95
    }
  };
  return <div className="relative w-full min-h-screen bg-[#0B1120] overflow-auto" data-id="element-449">
      {/* Background */}
      <StarField data-id="element-450" />

      {/* Header */}
      <header className="sticky top-0 z-50 bg-gradient-to-b from-[#0B1120] to-[#0B1120]/95 backdrop-blur-sm border-b border-[#A78BFA]/20" data-id="element-451">
        <div className="px-8 py-4" data-id="element-452">
          <div className="flex items-center justify-between" data-id="element-453">
            {/* Left: Back & Title */}
            <div className="flex items-center gap-6" data-id="element-454">
              <button onClick={() => window.history.back()} className="p-2 glass-panel rounded-lg hover:bg-white/10 transition-colors" data-id="element-455">
                <ArrowLeft className="w-5 h-5 text-gray-400" data-id="element-456" />
              </button>
              <div data-id="element-457">
                <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-458">
                  <div className="w-10 h-10 rounded-xl bg-[#A78BFA]/20 flex items-center justify-center border border-[#A78BFA]/30" data-id="element-459">
                    <Users className="w-6 h-6 text-[#A78BFA]" data-id="element-460" />
                  </div>
                  易教·伴学 智慧伴学
                </h1>
                <p className="text-sm text-gray-400 mt-1" data-id="element-461">
                  苏格拉底式对话 · 启发式引导 · 个性化陪伴
                </p>
              </div>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-4" data-id="element-462">
              <div className="flex items-center gap-2 glass-panel px-3 py-2 rounded-lg border border-white/10" data-id="element-463">
                <Calendar className="w-4 h-4 text-gray-400" data-id="element-464" />
                <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="bg-transparent text-white text-sm focus:outline-none" data-id="element-465">
                  <option value="week" data-id="element-466">本周</option>
                  <option value="month" data-id="element-467">本月</option>
                  <option value="semester" data-id="element-468">本学期</option>
                </select>
              </div>
              <button className="flex items-center gap-2 glass-panel px-4 py-2 rounded-lg hover:bg-white/10 transition-colors border border-white/10" data-id="element-469">
                <Download className="w-4 h-4 text-gray-400" data-id="element-470" />
                <span className="text-white text-sm" data-id="element-471">导出报告</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-8 py-6" data-id="element-472">
        {/* Top Stats Bar */}
        <div className="grid grid-cols-6 gap-4 mb-6" data-id="element-473">
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-474">
            <div className="text-xs text-gray-400 mb-1" data-id="element-475">对话总数</div>
            <div className="text-3xl font-bold text-[#A78BFA]" data-id="element-476">
              {data.overview.totalSessions}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-477">
            <div className="text-xs text-gray-400 mb-1" data-id="element-478">活跃学生</div>
            <div className="text-3xl font-bold text-green-400" data-id="element-479">
              {data.overview.activeStudents}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-480">
            <div className="text-xs text-gray-400 mb-1" data-id="element-481">平均时长</div>
            <div className="text-3xl font-bold text-blue-400" data-id="element-482">
              {data.overview.avgSessionTime}
              <span className="text-sm" data-id="element-483">min</span>
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-484">
            <div className="text-xs text-gray-400 mb-1" data-id="element-485">满意度</div>
            <div className="text-3xl font-bold text-orange-400" data-id="element-486">
              {data.overview.satisfactionRate}%
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-487">
            <div className="text-xs text-gray-400 mb-1" data-id="element-488">解决问题</div>
            <div className="text-3xl font-bold text-pink-400" data-id="element-489">
              {data.overview.questionsSolved}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-490">
            <div className="text-xs text-gray-400 mb-1" data-id="element-491">知识点覆盖</div>
            <div className="text-3xl font-bold text-purple-400" data-id="element-492">
              {data.overview.knowledgePointsCovered}
            </div>
          </div>
        </div>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-12 gap-6" data-id="element-493">
          {/* Left Column - Conversation Quality & Learning Modes */}
          <div className="col-span-3 space-y-6" data-id="element-494">
            {/* AI Conversation Quality */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-495">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-496">
                <MessageSquare className="w-5 h-5 text-[#A78BFA]" data-id="element-497" />
                AI对话质量分析
              </h3>
              <div className="space-y-4" data-id="element-498">
                <div data-id="element-499">
                  <div className="flex items-center justify-between mb-2" data-id="element-500">
                    <span className="text-gray-400 text-sm" data-id="element-501">清晰度</span>
                    <span className="text-[#A78BFA] font-bold" data-id="element-502">
                      {data.conversationQuality.clarityScore}%
                    </span>
                  </div>
                  <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-503">
                    <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${data.conversationQuality.clarityScore}%`
                  }} data-id="element-504"></div>
                  </div>
                </div>
                <div data-id="element-505">
                  <div className="flex items-center justify-between mb-2" data-id="element-506">
                    <span className="text-gray-400 text-sm" data-id="element-507">相关性</span>
                    <span className="text-[#A78BFA] font-bold" data-id="element-508">
                      {data.conversationQuality.relevanceScore}%
                    </span>
                  </div>
                  <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-509">
                    <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${data.conversationQuality.relevanceScore}%`
                  }} data-id="element-510"></div>
                  </div>
                </div>
                <div data-id="element-511">
                  <div className="flex items-center justify-between mb-2" data-id="element-512">
                    <span className="text-gray-400 text-sm" data-id="element-513">深度</span>
                    <span className="text-[#A78BFA] font-bold" data-id="element-514">
                      {data.conversationQuality.depthScore}%
                    </span>
                  </div>
                  <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-515">
                    <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${data.conversationQuality.depthScore}%`
                  }} data-id="element-516"></div>
                  </div>
                </div>
                <div data-id="element-517">
                  <div className="flex items-center justify-between mb-2" data-id="element-518">
                    <span className="text-gray-400 text-sm" data-id="element-519">引导性</span>
                    <span className="text-[#A78BFA] font-bold" data-id="element-520">
                      {data.conversationQuality.guidanceScore}%
                    </span>
                  </div>
                  <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-521">
                    <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${data.conversationQuality.guidanceScore}%`
                  }} data-id="element-522"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Learning Mode Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-523">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-524">
                <Lightbulb className="w-5 h-5 text-[#A78BFA]" data-id="element-525" />
                学习模式分布
              </h3>
              <div className="relative w-48 h-48 mx-auto mb-4" data-id="element-526">
                <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-527">
                  {data.learningModeDistribution.map((item, index, arr) => {
                  const total = arr.reduce((sum, i) => sum + i.count, 0);
                  const startAngle = arr.slice(0, index).reduce((sum, i) => sum + i.count / total * 360, 0);
                  const angle = item.count / total * 360;
                  const startRad = startAngle * Math.PI / 180;
                  const endRad = (startAngle + angle) * Math.PI / 180;
                  const largeArc = angle > 180 ? 1 : 0;
                  const x1 = 100 + 80 * Math.cos(startRad);
                  const y1 = 100 + 80 * Math.sin(startRad);
                  const x2 = 100 + 80 * Math.cos(endRad);
                  const y2 = 100 + 80 * Math.sin(endRad);
                  return <path key={index} d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={item.color} opacity="0.8" data-id="element-528" />;
                })}
                  <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-529" />
                </svg>
              </div>
              <div className="space-y-2" data-id="element-530">
                {data.learningModeDistribution.map((item, index) => <div key={index} className="flex items-center justify-between text-xs" data-id="element-531">
                    <div className="flex items-center gap-2" data-id="element-532">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-533"></div>
                      <span className="text-gray-300" data-id="element-534">{item.mode}</span>
                    </div>
                    <span className="text-white font-bold" data-id="element-535">
                      {item.percentage}%
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Learning Effectiveness */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-536">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-537">
                <Target className="w-5 h-5 text-[#A78BFA]" data-id="element-538" />
                学习效果评估
              </h3>
              <div className="grid grid-cols-2 gap-3" data-id="element-539">
                <div className="text-center p-3 bg-white/5 rounded-lg" data-id="element-540">
                  <div className="text-2xl font-bold text-[#A78BFA] mb-1" data-id="element-541">
                    {data.learningEffectiveness.knowledgeRetention}%
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-542">知识留存</div>
                </div>
                <div className="text-center p-3 bg-white/5 rounded-lg" data-id="element-543">
                  <div className="text-2xl font-bold text-green-400 mb-1" data-id="element-544">
                    {data.learningEffectiveness.conceptUnderstanding}%
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-545">概念理解</div>
                </div>
                <div className="text-center p-3 bg-white/5 rounded-lg" data-id="element-546">
                  <div className="text-2xl font-bold text-blue-400 mb-1" data-id="element-547">
                    {data.learningEffectiveness.applicationAbility}%
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-548">应用能力</div>
                </div>
                <div className="text-center p-3 bg-white/5 rounded-lg" data-id="element-549">
                  <div className="text-2xl font-bold text-purple-400 mb-1" data-id="element-550">
                    {data.learningEffectiveness.selfLearningAbility}%
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-551">自学能力</div>
                </div>
              </div>
            </div>
          </div>

          {/* Center Column - Engagement & Thinking Skills */}
          <div className="col-span-6 space-y-6" data-id="element-552">
            {/* Student Engagement Trend */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-553">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-554">
                <TrendingUp className="w-5 h-5 text-[#A78BFA]" data-id="element-555" />
                学生参与度趋势
              </h3>
              <div className="h-64 relative" data-id="element-556">
                <div className="absolute inset-0 flex items-end justify-between gap-2" data-id="element-557">
                  {data.engagementTrend.map((item, index) => <div key={index} className="flex-1 flex flex-col items-center" data-id="element-558">
                      <div className="w-full flex flex-col items-center gap-1" data-id="element-559">
                        <div className="w-full bg-gradient-to-t from-[#A78BFA] to-[#8B5CF6] rounded-t flex items-start justify-center pt-2" style={{
                      height: `${item.sessions / 3000 * 200}px`
                    }} data-id="element-560">
                          <span className="text-white text-xs font-bold" data-id="element-561">
                            {item.sessions}
                          </span>
                        </div>
                        <div className="text-xs text-gray-400" data-id="element-562">
                          {item.avgTime}min
                        </div>
                      </div>
                      <span className="text-gray-400 text-xs mt-2" data-id="element-563">
                        {item.date}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>

            {/* Thinking Skills Improvement */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-564">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-565">
                <Lightbulb className="w-5 h-5 text-[#A78BFA]" data-id="element-566" />
                思维能力提升
              </h3>
              <div className="space-y-4" data-id="element-567">
                {data.thinkingSkillsImprovement.map((skill, index) => <div key={index} data-id="element-568">
                    <div className="flex items-center justify-between mb-2" data-id="element-569">
                      <span className="text-white text-sm" data-id="element-570">{skill.skill}</span>
                      <div className="flex items-center gap-3" data-id="element-571">
                        <span className="text-gray-400 text-xs" data-id="element-572">
                          基线: {skill.baseline}%
                        </span>
                        <span className="text-[#A78BFA] font-bold" data-id="element-573">
                          当前: {skill.improvement}%
                        </span>
                        <div className="flex items-center gap-1 text-green-400 text-xs" data-id="element-574">
                          <TrendingUp className="w-3 h-3" data-id="element-575" />
                          <span data-id="element-576">+{skill.improvement - skill.baseline}%</span>
                        </div>
                      </div>
                    </div>
                    <div className="relative h-3 bg-white/5 rounded-full overflow-hidden" data-id="element-577">
                      <div className="absolute h-full bg-white/10 rounded-full" style={{
                    width: `${skill.baseline}%`
                  }} data-id="element-578"></div>
                      <div className="absolute h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${skill.improvement}%`
                  }} data-id="element-579"></div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Subject Usage */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-580">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-581">
                <BookOpen className="w-5 h-5 text-[#A78BFA]" data-id="element-582" />
                学科使用情况
              </h3>
              <div className="space-y-3" data-id="element-583">
                {data.subjectUsage.map((subject, index) => <div key={index} className="flex items-center justify-between p-4 bg-white/5 rounded-lg" data-id="element-584">
                    <div className="flex items-center gap-4 flex-1" data-id="element-585">
                      <span className="text-white font-medium w-16" data-id="element-586">
                        {subject.subject}
                      </span>
                      <div className="flex-1" data-id="element-587">
                        <div className="flex items-center justify-between mb-1" data-id="element-588">
                          <span className="text-xs text-gray-400" data-id="element-589">
                            对话次数
                          </span>
                          <span className="text-white font-bold text-sm" data-id="element-590">
                            {subject.sessions}
                          </span>
                        </div>
                        <div className="h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-591">
                          <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                        width: `${subject.sessions / 5000 * 100}%`
                      }} data-id="element-592"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4 ml-4" data-id="element-593">
                      <div className="text-center" data-id="element-594">
                        <div className="text-xs text-gray-400" data-id="element-595">平均时长</div>
                        <div className="text-sm font-bold text-blue-400" data-id="element-596">
                          {subject.avgTime}min
                        </div>
                      </div>
                      <div className="text-center" data-id="element-597">
                        <div className="text-xs text-gray-400" data-id="element-598">满意度</div>
                        <div className="text-sm font-bold text-green-400" data-id="element-599">
                          {subject.satisfaction}%
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Right Column - Rankings & Distribution */}
          <div className="col-span-3 space-y-6" data-id="element-600">
            {/* Top Knowledge Points */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-601">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-602">
                <Award className="w-5 h-5 text-[#A78BFA]" data-id="element-603" />
                高频知识点
              </h3>
              <div className="space-y-2" data-id="element-604">
                {data.topKnowledgePoints.map(point => <div key={point.rank} className="flex items-center justify-between p-3 bg-white/5 rounded-lg hover:bg-white/10 transition-colors" data-id="element-605">
                    <div className="flex items-center gap-3 flex-1" data-id="element-606">
                      <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${point.rank === 1 ? 'bg-yellow-400/20 text-yellow-400' : point.rank === 2 ? 'bg-gray-400/20 text-gray-400' : point.rank === 3 ? 'bg-orange-400/20 text-orange-400' : 'bg-[#A78BFA]/20 text-[#A78BFA]'}`} data-id="element-607">
                        {point.rank}
                      </div>
                      <div className="flex-1" data-id="element-608">
                        <div className="text-white text-sm font-medium" data-id="element-609">
                          {point.point}
                        </div>
                        <div className="text-xs text-gray-400" data-id="element-610">
                          {point.subject}
                        </div>
                      </div>
                    </div>
                    <div className="text-right" data-id="element-611">
                      <div className="text-[#A78BFA] font-bold text-sm" data-id="element-612">
                        {point.queries}
                      </div>
                      <div className="text-gray-400 text-xs" data-id="element-613">次查询</div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Popular Question Types */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-614">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-615">
                <MessageSquare className="w-5 h-5 text-[#A78BFA]" data-id="element-616" />
                热门问题类型
              </h3>
              <div className="space-y-3" data-id="element-617">
                {data.popularQuestionTypes.map((type, index) => <div key={index} data-id="element-618">
                    <div className="flex items-center justify-between mb-2" data-id="element-619">
                      <span className="text-white text-sm" data-id="element-620">{type.type}</span>
                      <span className="text-[#A78BFA] font-bold text-sm" data-id="element-621">
                        {type.percentage}%
                      </span>
                    </div>
                    <div className="h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-622">
                      <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full" style={{
                    width: `${type.percentage}%`
                  }} data-id="element-623"></div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Time Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-624">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-625">
                <Clock className="w-5 h-5 text-[#A78BFA]" data-id="element-626" />
                各时段使用分布
              </h3>
              <div className="space-y-3" data-id="element-627">
                {data.timeDistribution.map((time, index) => <div key={index} className="p-3 bg-white/5 rounded-lg" data-id="element-628">
                    <div className="flex items-center justify-between mb-2" data-id="element-629">
                      <span className="text-white text-sm" data-id="element-630">{time.period}</span>
                      <span className="text-gray-400 text-xs" data-id="element-631">
                        {time.count}次
                      </span>
                    </div>
                    <div className="h-6 bg-white/10 rounded-full overflow-hidden" data-id="element-632">
                      <div className="h-full bg-gradient-to-r from-[#A78BFA] to-[#8B5CF6] rounded-full flex items-center justify-end pr-2" style={{
                    width: `${time.percentage}%`
                  }} data-id="element-633">
                        <span className="text-white text-xs font-bold" data-id="element-634">
                          {time.percentage}%
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* AI Response Quality */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-635">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-636">
                <Zap className="w-5 h-5 text-[#A78BFA]" data-id="element-637" />
                AI响应质量
              </h3>
              <div className="space-y-4" data-id="element-638">
                <div className="flex items-center justify-between" data-id="element-639">
                  <span className="text-gray-400 text-sm" data-id="element-640">平均响应时间</span>
                  <span className="text-white font-bold" data-id="element-641">
                    {data.responseQuality.avgResponseTime}s
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-642">
                  <span className="text-gray-400 text-sm" data-id="element-643">准确率</span>
                  <span className="text-[#A78BFA] font-bold" data-id="element-644">
                    {data.responseQuality.accuracyRate}%
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-645">
                  <span className="text-gray-400 text-sm" data-id="element-646">完整度</span>
                  <span className="text-green-400 font-bold" data-id="element-647">
                    {data.responseQuality.completenessRate}%
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-648">
                  <span className="text-gray-400 text-sm" data-id="element-649">有用性评分</span>
                  <span className="text-purple-400 font-bold" data-id="element-650">
                    {data.responseQuality.helpfulnessScore}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}